import { render, staticRenderFns } from "./LeaveApplication.vue?vue&type=template&id=b94afb0e"
import script from "./LeaveApplication.vue?vue&type=script&lang=js"
export * from "./LeaveApplication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports